export const bookingSteps = {
  CHOICE_LIST: 'bookingSteps.choiceList',
  SKI_SERVICE: 'bookingSteps.SkiService'
}
